import ReactDOM from 'react-dom';
import { Root } from './Root';
// eslint-disable-next-line
ReactDOM.render(<Root />, document.getElementById('root'));
